export default {
  'checkout:coupon:error:basket_value_too_low':
    "Fast geschafft, Dir fehlen noch {amount} CHF, um deinen Gutschein einzulösen. Stöber' einfach noch ein bisschen in unserem Shop.",
};
